/**
 * Sélecteur de variante du loader global.
 *
 * @remarks
 * Trois designs coexistent le temps de trancher (cf. session loader global) :
 * - `spin`     — symbole Alt en demi-rotations horaires (`GlobalLoader`).
 * - `mindmap`  — mind map clignotante autour d'une boussole (`GlobalLoaderMindMap`).
 * - `brackets` — chevrons `<` `>` qui s'écartent du wordmark ALT (`GlobalLoaderBrackets`).
 *
 * Changer `ACTIVE_VARIANT` suffit : les trois shells montent `ActiveGlobalLoader`.
 */

import { GlobalLoader } from './GlobalLoader';
import { GlobalLoaderMindMap } from './GlobalLoaderMindMap';
import { GlobalLoaderBrackets } from './GlobalLoaderBrackets';

const VARIANTS = {
  spin: GlobalLoader,
  mindmap: GlobalLoaderMindMap,
  brackets: GlobalLoaderBrackets,
} as const;

const ACTIVE_VARIANT: keyof typeof VARIANTS = 'brackets';

/**
 * Vrai composant (pas un alias `VARIANTS[ACTIVE_VARIANT]`) : React Fast
 * Refresh remplace le corps d'une fonction à chaud, mais ne suit pas un alias
 * qui change de cible — sans ça, changer `ACTIVE_VARIANT` exigeait un reload.
 */
export function ActiveGlobalLoader() {
  const Variant = VARIANTS[ACTIVE_VARIANT];
  return <Variant />;
}
